import { render, staticRenderFns } from "./UserCampaingTab.vue?vue&type=template&id=35668897&"
import script from "./UserCampaingTab.vue?vue&type=script&lang=js&"
export * from "./UserCampaingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports